import * as authActions from '../auth/actions';
import * as serverActions from '../server/actions';

//Commented out this class ,since the error handling is now done via AXIOS Interceptor level using the APIInterceptor.js --Sriram

/**
 * global error handler
 *
 * every action in the application which handles a server response error
 * should go through this handler.
 *
 * this handler will dispatch default actions for specific error types
 * unless a customHandler is provided.
 */
export const errorHandler = (err, dispatch, customHandler = null) => {

  // // seems to be swallowing all errors, not just api calls
  // // maybe related to raven?
  // // TODO: ask charles about above ^
  // if (!err.response) return console.error(err);

  // const { status } = err.response;
  // let msg = "Something went wrong with your request. Please try again";

  // // log client side error with Sentry Raven plugin
  // Raven.captureException(err);

  // if (customHandler) customHandler(err);
  // else {
  //   switch (status) {
  //     case 400:
  //       dispatch(serverActions.serverError({status, msg}));
  //       break;

  //     case 401:
  //       msg = "Your session has expired. Please log in again";

  //       dispatch(authActions.logout());
  //       dispatch(serverActions.serverError({status, msg}));

  //       break;

  //     case 403:
  //       msg = "You are not authorised for that action. Please log in again";

  //       dispatch(authActions.logout());
  //       dispatch(serverActions.serverError({status, msg}));

  //       break;

  //     case 404:
  //       dispatch(serverActions.serverError({status, msg}));
  //       break;

  //     case 500:
  //       dispatch(serverActions.serverError({status, msg}));
  //       break;

  //     default:
  //       dispatch(serverActions.serverError({status, msg}));
  //   }
  // }
};



// WEBPACK FOOTER //
// ./src/utils/errors.js